var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-6"},[_c('add-category')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }